<template>
  <div>
    <div class="toolbtn flex">
      <el-tooltip class="item" effect="dark" content="刷新" placement="top">
        <div @click="refresh()" class="cursorpointer margin-top10">
          <img
            src="@/assets/barsvg/icon／12sx(1).png"
            style="position: relative; top: 2px"
            alt=""
          />
          <span class="f12 pad-left5" style="color: #969eac">刷新</span>
        </div>
      </el-tooltip>
      <el-tooltip class="item" effect="dark" content="返回" placement="top">
        <callback></callback>
      </el-tooltip>
    </div>
    <el-skeleton
      class="width100 border-rd3"
      :loading="true"
      animated
      :throttle="500"
    >
      <template slot="template">
        <div class="flex-betweennocenter" style="min-height: 85vh">
          <div class="backwhite border-rd3 pad-left20 pad-right20 width15">
            <div style="width: 48px" class="margin-auto margin-top20">
              <img class="enpriseimg" src="@/assets/barsvg/1@2x_1.png" alt="" />
            </div>
            <p class="dimensional textalign-center margin-top20">
              {{ companytitle }}
            </p>
            <div class="centerbor"></div>

            <el-tree
              class="width100 margin-top20 eltreenode"
              :data="deptList"
              :props="defaultProps"
              @node-click="handleNodeClick"
            >
              <div
                class="custom-tree-node"
                slot-scope="{ node, data }"
                @mouseenter="filemouseenter(data)"
                @mouseleave="filemouseleave(data)"
              >
                <span>{{ node.label }}</span>
                <el-dropdown
                  placement="right"
                  trigger="click"
                  v-if="nodelabel == node.label"
                >
                  <img
                    style="height: 10px; margin-left: 20px"
                    src="@/assets/barsvg/icon／14gd.png"
                    alt=""
                    @click="muchdata(data)"
                  />
                  <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item
                      ><span @click="handleAddsmall()">新增子部门</span>
                    </el-dropdown-item>
                    <el-dropdown-item
                      ><span @click="handleUpdate()">部门修改</span>
                    </el-dropdown-item>
                    <!-- <el-dropdown-item
                      ><span @click="rename()">重命名</span>
                    </el-dropdown-item> -->
                    <el-dropdown-item>
                      <span @click="handleDeletes()">删除</span>
                    </el-dropdown-item>
                  </el-dropdown-menu>
                </el-dropdown>
              </div>
            </el-tree>
            <p class="margin-top20">
              <span class="attention f14" @click="handleAdd()">新增部门</span>
            </p>
          </div>
          <div class="width81 backwhite border-rd3">
            <div class="width96 margin-auto flex-betweennocenter margin-top20">
              <div class="dimensional">
                {{ departmentTitle }}
                <span class="nameid">ID:{{ departmentID }}</span>
              </div>
              <div>
                <span class="attention f14" @click="Visiblebindstafflist()"
                  >加入员工</span
                >
              </div>
            </div>
            <div class="width96 margin-auto margin-top30">
              <el-table
                :data="allperson"
                stripe
                class="eltable width100 margin-auto f14"
              >
                <el-table-column
                  type="index"
                  label="排序"
                  align="center"
                  width="200"
                >
                </el-table-column>
                <el-table-column label="ID" align="center" prop="user.id" />
                <el-table-column
                  label="员工姓名"
                  align="center"
                  prop="user.realname"
                />
                <el-table-column
                  label="学历"
                  align="center"
                  prop="qualification"
                />
                <el-table-column
                  label="电话"
                  align="center"
                  prop="user.mobile"
                />
                <el-table-column
                  label="操作"
                  align="center"
                  class-name="small-padding fixed-width"
                >
                  <template slot-scope="scope">
                    <div class="cursorpointer">
                      <span style="color: #52c5cb" @click="Personal(scope.row)"
                        >编辑</span
                      >
                      <span
                        class="pad-left10"
                        style="color: #52c5cb"
                        @click="Deleteperson(scope.row)"
                        >移除</span
                      >
                    </div>
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </div>
        </div>
      </template>
    </el-skeleton>

    <el-dialog
      title=""
      :visible.sync="dialogVisiblenull"
      :close-on-click-modal="false"
      :show-close="true"
      :center="true"
      :modal="true"
      :modal-append-to-body="true"
      :append-to-body="true"
      width="25%"
      class="errorbox"
    >
      <p class="textalign-left f16">提示</p>
      <div class="textalign-left margin-top10">
        <span class="errormessage">{{ errormessage }}</span>
      </div>
      <span slot="footer" class="dialog-footer">
        <span @click="dialogVisiblenull = false" class="errorbutton">
          确 定
        </span>
      </span>
    </el-dialog>
    <!-- 公司员工列表 -->
    <el-dialog
      title=""
      :visible.sync="dialogVisiblebindstafflist"
      :close-on-click-modal="false"
      :show-close="true"
      :center="true"
      :modal="true"
      :modal-append-to-body="true"
      :append-to-body="true"
      width="40%"
      class="errorboxs"
    >
      <div class="f16 width98 textalign-left dimensional">加入员工</div>
      <div class="width98 margin-auto margin-top30">
        <el-table
          :data="stafflist"
          stripe
          @selection-change="handleSelectionChange"
          class="eltable width100 margin-auto f14"
        >
          <el-table-column type="selection"> </el-table-column>
          <el-table-column
            label="员工姓名"
            align="center"
            prop="user.realname"
          />
          <el-table-column label="当前部门" align="center" prop="department" />
          <el-table-column label="电话" align="center" prop="user.mobile" />
          <el-table-column
            label="操作"
            align="center"
            class-name="small-padding fixed-width"
          >
            <template slot-scope="scope">
              <div class="cursorpointer">
                <span
                  class="pad-left10"
                  style="color: #52c5cb"
                  @click="addperson(scope.row)"
                  >加入</span
                >
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <p slot="footer" class="textalign-right">
        <el-button @click="dialogVisiblebindstafflist = false">取 消</el-button>
        <el-button type="primary" @click="muchaddperson()">加 入</el-button>
      </p>
    </el-dialog>
    <!-- 部门新增 -->
    <el-dialog
      title=""
      :visible.sync="dialogVisibleadd"
      :close-on-click-modal="false"
      :show-close="true"
      :center="true"
      :modal="true"
      :modal-append-to-body="true"
      :append-to-body="true"
      width="30%"
      class="errorboxs"
    >
      <div class="f16 width98 textalign-left dimensional">部门新增</div>
      <div class="backwihte lineheight30 margin-top40">
        <div class="bg-box">
          <p class="textalign-left">所属部门</p>
          <div class="box-right">
            <el-dropdown
              trigger="click"
              class="width100"
              ref="messageDrop"
              @command="visiblechanges"
            >
              <el-input
                placeholder="请输入所属部门"
                v-model="parent_os"
                maxlength="0"
              />
              <el-dropdown-menu slot="dropdown" class="width27">
                <el-dropdown-item command="一级">
                  {{ this.companytitle }}
                </el-dropdown-item>
                <el-dropdown-item>
                  <el-tree
                    class="eltreenodes"
                    :data="deptList"
                    :props="defaultProps"
                    :default-expand-all="true"
                    @node-click="handleNodeClicks"
                  ></el-tree>
                </el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </div>
        </div>
        <div class="bg-box">
          <p class="textalign-left">请选择部门属性</p>
          <div class="textalign-left">
            <el-checkbox v-model="checked" :true-label="1" :false-label="0"
              >研发部门</el-checkbox
            >
            <el-checkbox v-model="checkeds" :true-label="1" :false-label="0"
              >财务部门</el-checkbox
            >
          </div>
        </div>
        <div class="bg-box">
          <p class="textalign-left">部门名称</p>
          <div class="box-right">
            <el-input
              class="inputDeep"
              placeholder="请输入部门名称"
              v-model="title"
            />
          </div>
        </div>
        <div class="bg-box">
          <p class="textalign-left">序号</p>
          <div class="box-right">
            <el-input
              class="inputDeep"
              placeholder=" 请输入排序号"
              v-model="sort_id"
            />
          </div>
        </div>
      </div>
      <p slot="footer" class="textalign-right">
        <el-button @click="dialogVisibleadd = false">取 消</el-button>
        <el-button type="primary" @click="Savechanges()">确 定</el-button>
      </p>
    </el-dialog>
    <!-- 部门修改 -->
    <el-dialog
      title=""
      :visible.sync="dialogVisiblemodify"
      :close-on-click-modal="false"
      :show-close="true"
      :center="true"
      :modal="true"
      :modal-append-to-body="true"
      :append-to-body="true"
      width="30%"
      class="errorboxs"
    >
      <div class="f16 width98 textalign-left dimensional">部门修改</div>
      <div class="backwihte lineheight30 margin-top40">
        <div class="bg-box">
          <p class="textalign-left">请选择部门属性</p>
          <div class="textalign-left">
            <el-checkbox v-model="checked" :true-label="1" :false-label="0"
              >研发部门</el-checkbox
            >
            <el-checkbox v-model="checkeds" :true-label="1" :false-label="0"
              >财务部门</el-checkbox
            >
          </div>
        </div>
        <div class="bg-box">
          <p class="textalign-left">部门名称</p>
          <div class="box-right">
            <el-input
              class="inputDeep"
              placeholder="请输入部门名称"
              v-model="titles"
            />
          </div>
        </div>
        <div class="bg-box">
          <p class="textalign-left">序号</p>
          <div class="box-right">
            <el-input
              class="inputDeep"
              placeholder="请输入序号"
              v-model="sort_ids"
            />
          </div>
        </div>
      </div>
      <p slot="footer" class="textalign-right">
        <el-button @click="dialogVisiblemodify = false">取 消</el-button>
        <el-button type="primary" @click="Savechangemodify()">确 定</el-button>
      </p>
    </el-dialog>
    <!-- 人员编辑 -->
    <el-dialog
      title=""
      :visible.sync="dialogVisiblePersonal"
      :close-on-click-modal="false"
      :show-close="true"
      :center="true"
      :modal="true"
      :modal-append-to-body="true"
      :append-to-body="true"
      width="40%"
      class=""
    >
      <p class="textalign-left f16 dimensional">员工编辑</p>
      <el-form
        ref="form"
        :model="form"
        label-width="0"
        class="width96 margin-auto flex-betweenwrap margin-top20 f14"
      >
        <el-form-item label="" class="width45">
          <p>部门选择</p>
          <el-select
            placeholder="请选择部门"
            v-model="form.dep_id"
            class="width100"
            :filterable="true"
          >
            <el-option label="---  请选择  ---" value=""></el-option>
            <el-option
              class="width100"
              v-for="item in optiondep_id"
              :key="item.id"
              :label="item.title"
              :value="item.id"
            >
            </el-option
          ></el-select>
        </el-form-item>
        <el-form-item label="" class="width45">
          <p>员工薪资(元/月)</p>
          <el-input placeholder="10000" v-model="form.wage"></el-input>
        </el-form-item>
        <el-form-item label="" class="width45">
          <p>员工性别</p>
          <el-select
            placeholder="请选择性别"
            v-model="form.sex"
            class="width100"
            :filterable="true"
          >
            <el-option label="---  请选择  ---" value=""></el-option>
            <el-option
              class="width100"
              v-for="item in options"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option
          ></el-select>
        </el-form-item>
        <el-form-item label="" class="width45">
          <p>出生年月</p>
          <el-date-picker
            style="width: 100%"
            v-model="form.birthday"
            type="date"
            placeholder="请选择出生年月"
            value-format="yyyy-MM-dd"
            :editable="false"
          ></el-date-picker>
        </el-form-item>
        <el-form-item label="" class="width45">
          <p>最高学历</p>
          <el-select
            placeholder="  请选择最高学历
"
            v-model="form.qualification"
            class="width100"
            :filterable="true"
          >
            <el-option label="---  请选择  ---" value=""></el-option>
            <el-option
              class="width100"
              v-for="item in optionsxl"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option
          ></el-select>
        </el-form-item>
        <el-form-item label="" class="width45">
          <p>所学专业</p>
          <el-input
            placeholder="请输入所学专业"
            v-model="form.major"
          ></el-input>
        </el-form-item>
        <el-form-item label="" class="width45">
          <p>评定职称</p>
          <el-input placeholder="请选择职称" v-model="form.rank"></el-input>
        </el-form-item>
        <el-form-item label="" class="width45">
          <p>入职时间</p>
          <el-date-picker
            style="width: 100%"
            v-model="form.entry"
            type="date"
            placeholder="请选择入职时间"
            value-format="yyyy-MM-dd"
            :editable="false"
          ></el-date-picker>
        </el-form-item>
        <el-form-item label="" class="width45">
          <p>离职时间</p>
          <el-date-picker
            style="width: 100%"
            v-model="form.departure"
            type="date"
            placeholder="请选择离职时间"
            value-format="yyyy-MM-dd"
            :editable="false"
          ></el-date-picker>
        </el-form-item>
        <el-form-item label="" class="width100">
          <p>所属企业</p>
          <el-input
            placeholder="外部人员请输入所属单位"
            v-model="form.company"
          ></el-input>
        </el-form-item>
        <el-form-item label="" class="width100">
          <p>备注信息</p>
          <el-input
            placeholder="备注信息"
            type="textarea"
            :autosize="autosize"
            v-model="form.remark"
          ></el-input>
        </el-form-item>

        <div class="width100 margin-top20 textalign-right">
          <el-button @click="dialogVisiblePersonal = false">取 消</el-button
          ><el-button type="primary" @click="onSubmit()">确 定</el-button>
        </div>
      </el-form>
    </el-dialog>
  </div>
</template>
<script>
import {
  eosindex,
  eossave,
  eosdel,
  eosupdate,
  eosstaff,
  eosjoin,
  bindstafflist,
  bindeditstaff,
} from "@/api/loader/loder.api";
import callback from "@/components/callback.vue";
import BUS from "@/BUS/BUS";
export default {
  data() {
    return {
      errormessage: "",
      dialogVisiblenull: false,
      dialogVisibleadd: false,
      dialogVisiblemodify: false,
      // dialogVisiblerename: false,
      dialogVisiblebindstafflist: false,
      dialogVisiblePersonal: false,
      companytitle: "",
      departmentID: "",
      departmentTitle: "",
      rowall: [],
      loading: true,
      serchkey: true,
      input: "",
      page: [],
      deptList: [],
      parent_os: "",
      title: "",
      parent_id: "",
      dev: "",
      checked: 0,
      checkeds: 0,
      sort_id: "",
      sort_ids: "",
      titles: "",
      parent_ids: "",
      parent_oss: "",
      devs: "",
      rowid: "",
      defaultProps: {
        children: "child",
        label: "title",
      },
      nodelabel: "",
      allperson: [],
      stafflist: [],
      multipleSelection: [],
      form: {
        name: "",
        wage: "", //薪资
        sex: "", //性别
        company: "", //所属单位
        birthday: "", //出生日期
        rank: "", //职称
        major: "", //专业
        qualification: "", //学历
        remark: "", //备注
        authority: "",
        dep_id: "",
        departure: "",
        entry: "",
      },
      autosize: {
        minRows: 3,
        maxRows: 1000,
      },
      options: [
        {
          value: "男",
          label: "男",
        },
        {
          value: "女",
          label: "女",
        },
      ],
      optionsxl: [
        {
          value: "小学",
          label: "小学",
        },
        {
          value: "初中",
          label: "初中",
        },
        {
          value: "高中",
          label: "高中",
        },
        {
          value: "专科教育",
          label: "专科教育",
        },
        {
          value: "本科教育",
          label: "本科教育",
        },
        {
          value: "研究生及以上",
          label: "研究生及以上",
        },
      ],
      optiondep_id: [],
    };
  },
  components: {
    callback,
  },

  methods: {
    // 个人资料
    Personal(row) {
      this.dialogVisiblePersonal = true;
      this.rowid = row.id;
      this.form.authority = row.authority; // 员工列表主键id
      this.form.wage = row.wage; //薪资
      this.form.sex = row.sex; //性别
      this.form.company = row.company; //所属单位
      this.form.birthday = row.birthday; //出生日期
      // this.depment = row.department; //所在部门
      this.form.rank = row.rank; //职称
      this.form.major = row.major; //专业
      this.form.qualification = row.qualification; //学历
      this.form.remark = row.remark; //备注
      if (row.dep_id == 0) {
        this.form.dep_id = "";
      } else {
        this.form.dep_id = row.dep_id;
      }
      this.form.entry = row.entry;
      this.form.departure = row.departure;
    },
    // 检索
    onSubmit() {
      bindeditstaff({
        id: this.rowid, // 员工列表主键id
        wage: this.form.wage, //薪资
        sex: this.form.sex, //性别
        company: this.form.company, //所属单位
        birthday: this.form.birthday, //出生日期
        // department: this.depment, //所在部门
        rank: this.form.rank, //职称
        major: this.form.major, //专业
        qualification: this.form.qualification, //学历
        remark: this.form.remark, //备注
        dep_id: this.form.dep_id,
        entry: this.form.entry,
        departure: this.form.departure,
      }).then((res) => {
        if (res.data.code == 200) {
          this.refresh();
          this.dialogVisiblePersonal = false;
        } else {
          this.dialogVisiblenull = true;
          this.errormessage = res.data.msg;
        }
      });
    },
    // 加入人员弹窗
    Visiblebindstafflist() {
      bindstafflist({
        all: 1,
      }).then((res) => {
        if (res.data.code == 200) {
          this.stafflist = res.data.data;
          this.stafflist.forEach((i) => {
            if (i.authority == 0) {
              i.authority = "企业负责人";
            }
            if (i.authority == 1) {
              i.authority = "管理员";
            }
            if (i.authority == 2) {
              i.authority = "普通人员";
            }
          });
        } else {
          this.dialogVisiblenull = true;
          this.errormessage = res.data.msg;
        }
      });
      this.dialogVisiblebindstafflist = true;
    },
    // 选择
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    // 单个人员加入
    addperson(row) {
      eosjoin({ dep_id: this.departmentID, users: [row.user.id] }).then(
        (res) => {
          if (res.data.code == 200) {
            this.dialogVisiblebindstafflist = false;
            this.allperson = res.data.data;
          } else {
            this.dialogVisiblenull = true;
            this.errormessage = res.data.msg;
          }
        }
      );
    },
    // 多个人员加入
    muchaddperson() {
      let alluserid = [];
      this.multipleSelection.forEach((i) => {
        alluserid.push(i.user.id);
      });
      eosjoin({ dep_id: this.departmentID, users: alluserid }).then((res) => {
        if (res.data.code == 200) {
          this.dialogVisiblebindstafflist = false;
          this.allperson = res.data.data;
        } else {
          this.dialogVisiblenull = true;
          this.errormessage = res.data.msg;
        }
      });
    },
    // 移除人员
    Deleteperson(row) {
      bindeditstaff({
        id: row.id,
        dep_id: 0,
      }).then((res) => {
        if (res.data.code == 200) {
          // this.getList();
          eosstaff({ dep_id: this.departmentID }).then((i) => {
            if (i.data.code == 200) {
              this.allperson = i.data.data;
            }
          });
        } else {
          this.dialogVisiblenull = true;
          this.errormessage = res.data.msg;
        }
      });
    },
    filemouseenter(index) {
      this.nodelabel = index.title;
    },
    filemouseleave(index) {
      this.nodelabel = index.title;
    },
    handleNodeClick(data) {
      this.departmentID = data.id;
      eosstaff({ dep_id: data.id }).then((i) => {
        if (i.data.code == 200) {
          this.allperson = i.data.data;
        }
      });
      this.departmentTitle = data.title;
      this.rowall = data;
    },
    handleNodeClicks(data) {
      this.parent_os = data.title;
      this.parent_id = data.id;
      this.$refs.messageDrop.hide();
    },
    visiblechanges(command) {
      if (command == "一级") {
        this.parent_os = this.companytitle;
        this.parent_id = 0;
      }
    },
    handleNodeClickss(data) {
      this.parent_oss = data.title;
      this.parent_ids = data.id;
      this.$refs.messageDrops.hide();
    },
    visiblechangess(command) {
      if (command == "一级") {
        this.parent_oss = this.companytitle;
        this.parent_ids = 0;
      }
    },
    /** 查询部门列表 */
    getList() {
      this.$loading.show(); // 显示loading
      eosindex({}).then((res) => {
        if (res.data.code == 200) {
          this.$loading.hide(); // 隐藏loading
          this.optiondep_id = res.data.data;
          this.deptList = res.data.data;
          this.companytitle = window.sessionStorage.getItem("companytitle");
          // this.departmentID = this.deptList[0].id;
          eosstaff({ dep_id: this.departmentID }).then((i) => {
            if (i.data.code == 200) {
              this.allperson = i.data.data;
            }
          });
          this.departmentTitle = this.deptList[0].title;
          this.rowall = this.deptList[0];
        } else {
          this.$loading.hide(); // 隐藏loading
          this.dialogVisiblenull = true;
          this.errormessage = res.data.msg;
        }
      });
    },
    /** 新增按钮操作 */
    handleAdd(row) {
      this.dialogVisibleadd = true;
      this.nodelabel = "";
      this.parent_id = "";
      this.parent_os = "";
      this.title = "";

      this.checked = 0;
      this.checkeds = 0;
    },
    handleAddsmall() {
      this.dialogVisibleadd = true;
      this.nodelabel = "";
      this.parent_id = this.rowall.id;
      this.parent_os = this.rowall.title;
      this.title = "";
      this.checked = this.rowall.dev;
      this.checkeds = this.rowall.finance;
    },
    // 新增提交
    Savechanges() {
      eossave({
        sort_id: this.sort_id,
        parent_id: this.parent_id,
        parent_os: this.parent_os,
        title: this.title,
        dev: this.checked,
        finance: this.checkeds,
      }).then((res) => {
        if (res.data.code == 200) {
          this.getList();
          this.dialogVisibleadd = false;
        } else {
          this.dialogVisiblenull = true;
          this.errormessage = res.data.msg;
        }
      });
    },
    /** 修改按钮操作 */
    handleUpdate() {
      this.nodelabel = "";
      this.dialogVisiblemodify = true;
      this.rowid = this.rowall.id;
      this.parent_ids = this.rowall.parent_id;
      this.parent_oss = this.rowall.parent_os;
      this.sort_ids = this.rowall.sort_id;
      this.titles = this.rowall.title;
      this.checked = this.rowall.dev;
      this.checkeds = this.rowall.finance;
      // this.addAttr(this.deptList);
    },
    Savechangemodify() {
      eosupdate({
        id: this.rowid,
        sort_id: this.sort_ids,
        parent_id: this.parent_ids,
        parent_os: this.parent_oss,
        title: this.titles,
        dev: this.checked,
        finance: this.checkeds,
      }).then((res) => {
        if (res.data.code == 200) {
          this.getList();
          this.dialogVisiblemodify = false;
        } else {
          this.dialogVisiblenull = true;
          this.errormessage = res.data.msg;
        }
      });
    },
    /** 删除按钮操作 */
    handleDelete(row) {
      this.nodelabel = "";
      this.$confirm("此操作将删除此部门, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          eosdel({
            id: row.id,
          }).then((res) => {
            if (res.data.code == 200) {
              this.getList();
            } else {
              this.dialogVisiblenull = true;
              this.errormessage = res.data.msg;
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消操作",
          });
        });
    },
    // 点击更多
    muchdata(data) {
      this.rowall = data;
    },
    // 重命名
    // rename() {
    //   this.dialogVisiblerename = true;
    // },
    // renamechanges() {
    //   eosupdate({
    //     id: this.rowall.id,
    //     sort_id: this.rowall.sort_id,
    //     parent_id: this.rowall.parent_id,
    //     parent_os: this.rowall.parent_os,
    //     title: this.renames,
    //     dev: this.rowall.dev,
    //   }).then((res) => {
    //     if (res.data.code == 200) {
    //       this.getList();
    //       this.dialogVisiblerename = false;
    //     } else {
    //       this.dialogVisiblenull = true;
    //       this.errormessage = res.data.msg;
    //     }
    //   });
    // },
    // 删除
    handleDeletes() {
      this.$confirm("此操作将删除此部门, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          eosdel({
            id: this.rowall.id,
          }).then((res) => {
            if (res.data.code == 200) {
              this.getList();
            } else {
              this.dialogVisiblenull = true;
              this.errormessage = res.data.msg;
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消操作",
          });
        });
    },
    refresh() {
      this.getList();
      this.nodelabel = "";
    },
  },

  created() {
    eosindex({}).then((res) => {
      if (res.data.code == 200) {
        this.$loading.hide(); // 隐藏loading
        this.optiondep_id = res.data.data;
        this.deptList = res.data.data;
        this.companytitle = window.sessionStorage.getItem("companytitle");
        this.departmentID = this.deptList[0].id;
        eosstaff({ dep_id: this.departmentID }).then((i) => {
          if (i.data.code == 200) {
            this.allperson = i.data.data;
          }
        });
        this.departmentTitle = this.deptList[0].title;
        this.rowall = this.deptList[0];
      } else {
        this.$loading.hide(); // 隐藏loading
        this.dialogVisiblenull = true;
        this.errormessage = res.data.msg;
      }
    });

    BUS.$on("serchkey", (data) => {
      this.serchkey = data;
    });
  },
  mounted() {},
};
</script>
<style scoped>
.bg-box {
  margin-top: 10px;
}
.enpriseimg {
  width: 48px;
  height: 48px;
  border-radius: 50%;
}
.centerbor {
  margin: 30px 0;
  border-top: 1px dashed #ccc;
}
.nameid {
  font-size: 12px;
  color: #fff;
  background: #7b83ea;
  border-radius: 10px;
  padding: 2px 8px;
}

.eltreenode >>> .el-tree-node__content {
  height: 40px;
  cursor: pointer;
}
.custom-tree-node {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-right: 10px;
}
.eltable >>> .el-table__header-wrapper th {
  background-color: #f8f8f9;
  height: 40px;
  font-size: 14px;
}
.eltreenode >>> .el-tree-node:focus {
  color: #52c5cb;
}
.eltreenodes >>> .el-tree-node:focus {
  background: #fff;
}
.errorbox >>> .el-dialog__body {
  text-align: center;
}
.errorboxs >>> .el-dialog__body {
  text-align: center;
}
.errorbox >>> .el-dialog {
  position: relative;
  top: 20%;
}
</style>